import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";

interface ApplicationCustomer {
	readonly phoneMobile?: string;
	readonly email?: string;
	readonly customerNumber?: string;
	readonly customerRole?: string;
	readonly isResident?: boolean;
}

export class ApplicationCustomersSchema
	implements IFormTableSchema<ApplicationCustomer>
{
	tableMetadata: TableMetadata<Partial<ApplicationCustomer>> = {
		dployTesterContext: "ApplicaitonCustomers",
		isReadOnlyRow: (rowData: any, cells: any) =>
			rowData?.engagementCustomerId &&
			rowData.engagementCustomerId !== rowData.customerId
	};

	columnMetadata: Partial<
		Record<keyof ApplicationCustomer, ColumnMetadata<ApplicationCustomer>>
	> = {
		phoneMobile: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		email: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		customerNumber: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		customerRole: {
			fieldType: FieldType.Select,
			isRequired: true
		},
		isResident: {
			fieldType: FieldType.Checkbox,
			hide: (value, rowData, cells, isPlaceholder, firstInGroup) => {
				const role = rowData["customerRole"] as Number | undefined;
				return role !== 12;
			},
			isEditableFunctions: {
				EditableIfHouseOwner: (form, row) => {
					const role = row.find(c => c.column.id === "customerRole")?.value as
						| Number
						| undefined;
					return role === 12;
				}
			}
		}
	};
}
